import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { SubscriptionList } from '../../../shared/models/asp.types';
import { BdcDashboardState } from '../../../store/bdcdashboard/bdcdashboard.reducer';
import * as fromActions from '../../../store/bdcdashboard/bdcdashboard.actions';
import * as fromSelectors from '../../../store/bdcdashboard/bdcdashboard.selectors';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { IAppointment, SortOrder, SourceSystem } from '@signal/asp-data-commons';
import { Router } from '@angular/router';
import { DateTime } from 'luxon';
import { DealerState } from '../../../store/dealer/dealer.reducer';
import { selectDealerCode } from '../../../store/dealer/dealer.selectors';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { getCustomerDisplayName, unsubscribeSubscriptions } from '../../../shared/services/util.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { getSearchAndSortedData } from 'src/app/modules/store/bdcdashboard/bdcdashboard.adapter';
import * as _ from 'lodash';

@Component({
  selector: 'app-delete-pending',
  templateUrl: './delete-pending.component.html',
  styleUrls: ['./delete-pending.component.scss']
})
export class DeletePendingComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean>;

  initColumns: any[] = [{ id: 'customerName', display: 'pendingAppointments.customerName' }, { id: 'contactInfo', display: 'pendingAppointments.customerContactInformation' },
  { id: 'model', display: 'pendingAppointments.vehicleModel', col: 'model' }, { id: 'vin', display: 'VIN', col: 'vin' },
  { id: 'appointmentStartDate', display: 'vehicleManagement.appointmentDateTime', col: 'appointmentStartDate' },
  { id: 'source', display: 'vehicleManagement.newUsedManual', col: 'source' }];

  columnsToDisplay = ['actions','select', 'customerName', 'contactInfo', 'model', 'vin',
    'appointmentStartDate','source'];
  columnsToDisplayForFilter = ['actions','selectFilter', 'customerNameFilter', 'contactInfoFilter', 'modelFilter', 'vinFilter',
    'appointmentStartDateFilter','sourceFilter'];

  initColumnsForFilter: any[] = [{id:'actionsFilter', display: 'deliveryChecklist.actions' },{id:'selectFilter', display :''}, { id: 'customerNameFilter', display: 'pendingAppointments.customerName' }, { id: 'contactInfoFilter', display: 'pendingAppointments.customerContactInformation' },
  { id: 'modelFilter', display: 'pendingAppointments.vehicleModel' }, { id: 'vinFilter', display: 'VIN' },
  { id: 'appointmentStartDateFilter', display: 'MM/DD/YYYY' },
  { id: 'sourceFilter', display: 'vehicleManagement.newUsedManual' }];
  subscriptions: SubscriptionList = {};
  allAppointmentsCount$: Observable<number>;
  appointments$: Observable<IAppointment[]>;
  dataSource: any;
  allAppointments: IAppointment[];
  appointments: IAppointment[];
  dealerCode$: Observable<string>;
  dealerCode: string;
  searchForm: UntypedFormGroup;
  searchValues  = [];
  isSearchLoading = false;
  sortingField  = 'appointmentStartDate';
  sortOrder  = SortOrder.ASC;
  
  constructor(
    private readonly BdcDashboardStateStore: Store<BdcDashboardState>,
    private readonly router: Router,
    private readonly dealerState: Store<DealerState>,
    public readonly dialog: MatDialog,
    private readonly formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.dealerCode$ = this.dealerState.select(selectDealerCode);
    this.subscriptions.dealerCode = this.dealerCode$.subscribe(code => {
      this.dealerCode = code;
    })
    this.isLoading$ = this.BdcDashboardStateStore.select(fromSelectors.selectPendingAppointmentsLoading);
    this.setupStore();
    this.InitializeSearchForm();
  }

  setupStore() {
    this.BdcDashboardStateStore.dispatch(new fromActions.LoadPendingAppointments({ type : 'deletePending', sortingField: this.sortingField,sortOrder: this.sortOrder}));
    this.allAppointmentsCount$ = this.BdcDashboardStateStore.select(fromSelectors.selectPendingAppointmentsCount);
    this.appointments$ = this.BdcDashboardStateStore.select(fromSelectors.selectPendingAppointments)
    this.subscriptions.appointmentData = this.appointments$.subscribe(data => {
      this.allAppointments = data;
      this.appointments = _.orderBy(this.allAppointments, [this.sortingField], [this.sortOrder]);
      this.dataSource = new MatTableDataSource(this.appointments);
      this.isSearchLoading = false;
    });
  }

  InitializeSearchForm() {
    this.searchForm = this.formBuilder.group({
      customerNameFilter: [''],
      contactInfoFilter: [''],
      modelFilter: [''],
      vinFilter: [''],
      appointmentStartDateFilter: [''],
      sourceFilter: ['']
    })
  }

  editAppointment(appointment: IAppointment) {
    this.router.navigate(['asp/bdc/testdrive'], {
      queryParams: {
        id: appointment.appointmentId,
        email: appointment.emailAddress,      }
    });
  }

  cancelAppointment($event, appointment) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      height: '220px',
      data: {
        popupTitle: 'pendingAppointments.cancelConfirmation',
        popupBodyText: 'serviceSchedule.areYouSureYouWantToCancelThisAppointment',
        saveButton: 'service.yes',
        cancelButton: 'service.no'
      },
      panelClass: 'asp-modal-container'
    });
    this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe((result) => {
      if (result.action === 'confirm') {
        this.BdcDashboardStateStore.dispatch(
          new fromActions.CancelPendingAppointments({ appointment, type: 'deletePending', count: this.allAppointments.length }));
      }
    });
  }

  getAppointmentCreatedDateTime(date: string, timeSlotId: string) {
    return `${DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('MM/dd/yyyy')}     ${timeSlotId}`;
  }

  getSource(source: string) {
    switch(source) {
      case SourceSystem.NVI :
        return 'pendingAppointments.new';
      case SourceSystem.UVI:
        return 'pendingAppointments.used';
      case SourceSystem.ME:
        return 'vehicleManagement.manual';
      default:
        return 'NA';
    }
  }

  getCustomerDisplayName(customer: any): string {
    return getCustomerDisplayName(customer);
  }

  getFormatedDate(date: string) {
    const dates= date.split(',');
    let dateArr = '';
    dates.forEach( val => {
      const replacedValue = val.trim();
      const foramteddDate = DateTime.fromFormat(replacedValue, 'MM-dd-yyyy').toFormat('yyyy-MM-dd');
      if(foramteddDate && foramteddDate !== 'Invalid DateTime') {
        dateArr += (dateArr.length ? `,${foramteddDate}` : foramteddDate);
      }
    })
    return dateArr;
  }

  searchAppointments() {
    if(this.searchValues.length > 0) {
    const searchData = {...this.searchForm.value};
    this.isSearchLoading = true;
    this.appointments = [];
    this.dataSource = new MatTableDataSource(this.appointments);
    this.appointments = getSearchAndSortedData(this.allAppointments, searchData, this.sortingField, this.sortOrder, true);
    this.dataSource = new MatTableDataSource(this.appointments);
    this.isSearchLoading = false;
  }
    else {
      this.isSearchLoading = true;
      this.appointments = [];
      this.dataSource = new MatTableDataSource(this.appointments);
      this.appointments = getSearchAndSortedData(this.allAppointments, {}, this.sortingField, this.sortOrder, false);
      this.dataSource = new MatTableDataSource(this.appointments);
      this.isSearchLoading = false;
    }
  }

  addSearchField(columnField, value) {
    const index = this.searchValues.findIndex(x => x?.column === columnField);
    if (index === -1 && !!value) {
      this.searchValues.push({ column: columnField, colValue: value });
    }
    else if (value) {
      this.searchValues[index].colValue = value;
    }
    else {
      this.searchValues.splice(index, 1);
    }
    this.searchAppointments();
  }

  onCloseFilterValue(searchColumn, index){
    this.searchValues.splice(index, 1);
    this.searchForm.get(searchColumn).patchValue('');
    this.searchAppointments();
  }

  clearFilters() {
    this.searchValues = [];
    this.InitializeSearchForm();
    this.searchAppointments();
  }

  sortChange(col: string) {
    if(this.sortingField === col) {
      this.sortOrder = this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC;
    }
    else {
      this.sortOrder = SortOrder.ASC;
    }
    this.sortingField = col;
    this.searchAppointments();
  }

   scrollDown() {
    const filterList = document.querySelector('.filter-group');
    filterList.scrollTop += 20;
  }

   scrollUp() {
    const filterList = document.querySelector('.filter-group');
    filterList.scrollTop -= 20;
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
  }

}

